import * as basic from '../../../config/basic'

export const blockchain = {
  banner: {
    img: 'https://static001.geekbang.org/resource/image/4c/20/4cc3293eabffc59444562c8c9c954e20.png',
    titleCh: '区块链赛道',
    titleEn: 'Blockchain'
  },
  blockchain: {
    list: [
      [
        {
          detailsText: {
            title: 'WeBankBlockchain-SmartDev 应用开发组件',
            img: 'https://static001.geekbang.org/resource/image/25/54/253b3975858734b560304a1898ae2b54.png',
            illustrate: [
              {
                illustrateContent: '组件的研发初衷在于打造低代码开发的组件库，全方位助力开发者高效、敏捷地开发区块链应用。包含了一套开放、轻量的开发组件集，覆盖合约的开发、编译、应用开发等环节，开发者可根据自己的情况选择相应开发工具，提升开发效率。其包括 WeBankBlockchain-SmartDev-Contract 智能合约库组件、WeBankBlockchain-SmartDev-SCGP(SmartContractGradlePlugin) 智能合约编译插件、WeBankBlockchain-SmartDev-Scaffold 区块链应用开发脚手架组件等。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/orgs/WeBankBlockchain/repositories',
            studyLink: 'https://smartdev-doc.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        }
      ],
      [
        {
          detailsText: {
            title: 'WeBankBlockchain-Data 数据治理',
            img: 'https://static001.geekbang.org/resource/image/fd/d2/fd83042eebf3e78fd44a54b472d2bdd2.png',
            illustrate: [
              {
                illustrateContent: '该套组件由数据仓库组件 (Data-Stash)、数据导出组件 (Data-Export)、数据对账组件 (Data-Reconcile) 三个相互独立、可插拔、可灵活组装的子组件构成，提供区块链数据挖掘、裁剪、扩容、可信存储、抽取、分析、审计、对账、监管等数据治理方面的关键能力，满足数据治理全流程开发场景的需求。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/orgs/WeBankBlockchain/repositories',
            studyLink: 'https://data-doc.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        },
        {
          detailsText: {
            title: 'WeBankBlockchain-Governance 多方协作治理',
            img: 'https://static001.geekbang.org/resource/image/dc/01/dc2a2364f30d8e8b8103e045e939ec01.png',
            illustrate: [
              {
                illustrateContent: '区块链多方协作治理通用组件由私钥管理组件（Governance-Key）、账户治理组件（Governance-Account）、权限治理组件（Governance-Authority）、证书管理组件（Governance-Cert）等组件构成。它们宛如高速行驶的汽车上的车轮、齿轮、传动组、传感器，协同助力提升应用开发效率。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/orgs/WeBankBlockchain/repositories',
            studyLink: 'https://governance-doc.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        },
        {
          detailsText: {
            title: 'WeBankBlockchain-OpenLedger 分布式账本',
            img: 'https://static001.geekbang.org/resource/image/33/yd/33da55fc91eb2a9a57bd64ac543b0yyd.png',
            illustrate: [
              {
                illustrateContent: '在践行区块链技术的路径上，行业需要直观易用、稳健合规，能与业务场景深度融合，合法合规地承载价值和进行流转的分布式账本方案。为此，微众银行区块链结合业务场景，梳理系统脉络，开源了分布式账本解决方案：WeBankBlockchain-OpenLedger。聚焦链上的“用户、业务方、权益、账户和账本”，建立与实际业务相匹配的账本体系，承载数字化权益的完整生命周期，以此形成多方参与的可信分布式账本。在治理方面，支持灵活的角色和权限模型，协助用户和业务方安全稳妥地管理链上账户，具备全面的审计监管能力。通过智能合约封装账本、账户、权益、组织模型，覆盖用户、业务方、托管人的协作关系，使得链上治理符合各行业熟知的运营管理习惯。提供开箱即用的业务级合约，合约支持复用与扩展；在业务层设计友好的接入方式，提供功能丰富、易于使用的接口，简化了业务系统接入的过程，极大地降低了开发成本。建立的区块链分布式账本功能完善、体验友好，可支持消费券、积分、资产证券化等多样化的场景'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/WeBankBlockchain/OpenLedger',
            studyLink: 'https://openledger.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        }
      ],
      [
        {
          detailsText: {
            title: 'WeIdentity 分布式身份管理',
            img: 'https://static001.geekbang.org/resource/image/50/f5/503a4c8160f4b60804d56b4793f756f5.png',
            illustrate: [
              {
                illustrateContent: 'WeIdentity 是一套基于区块链的分布式身份管理解决方案，致力于促进泛行业、跨机构、跨地域间的身份认证和数据合作。WeIdentity 提供分布式实体身份标识及管理、可信数据交换协议等一系列的基础层与应用接口，可实现实体对象（人或物）数据的安全授权与交换。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/WeBankBlockchain/WeIdentity',
            studyLink: 'https://weidentity.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        },
        {
          detailsText: {
            title: 'WeDPR 隐私保护',
            img: 'https://static001.geekbang.org/resource/image/20/a0/20f6a57263709d3ba0c6c6aa5b0ed9a0.png',
            illustrate: [
              {
                illustrateContent: '致力于解决业务数字化中隐私不“隐”、共享协作不可控等隐私保护风险痛点，在“数据可用不可见”的基础上更进一步，实现隐私数据的“可隐可现、可控可用”的5C隐私保护效果，消除隐私主体的隐私顾虑和业务创新的合规壁垒，助力基于隐私数据的核心价值互联和新兴商业探索，营造公平、对等、共赢的多方数据协作环境，达成数据价值跨主体融合和数据治理的可控平衡。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/WeBankBlockchain/WeDPR-Lab-Core',
            studyLink: 'https://wedpr-lab.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        },
        {
          detailsText: {
            title: 'WeCross 通用跨链',
            img: 'https://static001.geekbang.org/resource/image/60/42/600ac69eb3b9dyycca4670d6bc246c42.png',
            illustrate: [
              {
                illustrateContent: 'WeCross 致力于促进跨行业、机构和地域的跨区块链信任传递和商业合作，不局限于满足同构区块链平行扩展后的可信数据交换需求，还进一步探索解决异构区块链之间因底层架构、数据结构、接口协议、安全机制等多维异构性导致无法互联互通问题的有效方案。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/WeBankBlockchain/WeCross',
            studyLink: 'https://wecross.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        }
      ],
      [
        {
          detailsText: {
            title: 'WeEvent 消息协作',
            img: 'https://static001.geekbang.org/resource/image/98/48/9852b56a702530c34fd12f39d0648548.png',
            illustrate: [
              {
                illustrateContent: 'WeEvent 是一套分布式事件驱动架构，实现了可信、可靠、高效的跨机构、跨平台事件通知机制。WeEvent 致力于提升机构间合作效率，降低合作成本，打通应用程序、物联网、云服务和私有服务等不同平台，最终在不改变已有商业系统的开发语言、接入协议的情况下，实现跨机构、跨平台的事件通知与处理。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/WeBankBlockchain/WeEvent',
            studyLink: 'https://weeventdoc.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        },
        {
          detailsText: {
            title: 'Truora 可信预言机',
            img: 'https://static001.geekbang.org/resource/image/76/9c/7607a34490e66921b0b7db8ac46f1d9c.png',
            illustrate: [
              {
                illustrateContent: '作为连接联盟链和互联网的桥梁，Truora 致力于为链上链下建立安全可信的数据通道，以降低信任成本，进一步扩宽联盟链应用场景，促进联盟链生态繁荣。作为一整套中心化和多中心化技术方案的集合，用户在使用 Truora 时，可以根据不同的业务场景，以及对信任的要求度，进行灵活部署。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/WeBankBlockchain/Truora',
            studyLink: 'https://truora.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        },
        {
          detailsText: {
            title: 'Liquid 智能合约语言',
            img: 'https://static001.geekbang.org/resource/image/bb/30/bbd1d96d49e032c0fd671727998b9430.png',
            illustrate: [
              {
                illustrateContent: '基于安全（Security）、性能（Performance）、体验（Experience）及定制能力（Customization ）“SPEC” 四个方面的智能合约编程语言设计规范，全新的智能合约编程语言 Liquid 应运而生：支持使用加密原语对数据进行隐匿，从而确保数据资产与逻辑安全；通过优化执行引擎并结合并行化等技术，让智能合约的执行效率取得长足进步；提供敏捷、流畅、友好的开发体验；在语言层提供分布式协作、跨链协同等编程模型，实现灵活可定制。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/WeBankBlockchain/liquid',
            studyLink: 'https://liquid-doc.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        }
      ],
      [
        {
          detailsText: {
            title: 'WeBASE 中间件平台',
            img: 'https://static001.geekbang.org/resource/image/77/1d/77425b8a79f0ddc35ec5edb44422421d.png',
            illustrate: [
              {
                illustrateContent: 'WeBASE 是在区块链应用和底层节点之间搭建的中间件平台，面向多种对象，根据不同场景，打造丰富的功能组件和实用工具，提供友好的、可视化的可操作环境。WeBASE 可简化区块链应用开发流程，降低开发门槛，帮助开发者快速搭建区块链应用。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/WeBankBlockchain/WeBASE',
            studyLink: 'https://webasedoc.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        }
      ],
      [
        {
          detailsText: {
            title: 'FISCO BCOS 底层平台',
            img: 'https://static001.geekbang.org/resource/image/e2/6a/e2e54ab67880a6624aeb1c8e9f637b6a.png',
            illustrate: [
              {
                illustrateContent: 'FISCO BCOS 是国产安全可控的联盟链底层平台，由微众银行牵头组建的金链盟开源工作组协作打造，于2017年正式对外开源，为各行各业开展区块链应用提供可靠的基础设施。依托硬核技术实力，FISCO BCOS 助力实体经济发展的成效逐渐显现，目前已结出累累硕果。至今，FISCO BCOS 开源社区已汇聚超70000名个人成员、逾3000家机构，成功支持政务、金融、农业、公益、文娱、供应链、物联网等多个行业的数百个区块链应用场景落地，社区收集到的标杆应用超过200个，构建出庞大且活跃的联盟链开源生态。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/FISCO-BCOS/FISCO-BCOS',
            studyLink: 'https://fisco-bcos-documentation.readthedocs.io/zh_CN/latest/docs/community.html',
            study: '学习文档'
          }
        }
      ]
    ],
    mobileList: [
      [
        {
          detailsText: {
            title: 'WeBankBlockchain-SmartDev 应用开发组件',
            img: 'https://static001.geekbang.org/resource/image/a2/03/a220b8b9264b23d9c27bb8e916ebf803.png',
            illustrate: [
              {
                illustrateContent: '组件的研发初衷在于打造低代码开发的组件库，全方位助力开发者高效、敏捷地开发区块链应用。包含了一套开放、轻量的开发组件集，覆盖合约的开发、编译、应用开发等环节，开发者可根据自己的情况选择相应开发工具，提升开发效率。其包括 WeBankBlockchain-SmartDev-Contract 智能合约库组件、WeBankBlockchain-SmartDev-SCGP(SmartContractGradlePlugin) 智能合约编译插件、WeBankBlockchain-SmartDev-Scaffold 区块链应用开发脚手架组件等。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/orgs/WeBankBlockchain/repositories',
            studyLink: 'https://smartdev-doc.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        }
      ],
      [
        {
          detailsText: {
            title: 'WeBankBlockchain-Data 数据治理',
            img: 'https://static001.geekbang.org/resource/image/45/b2/451495bd1f5dcfc12204a27a783e86b2.png',
            illustrate: [
              {
                illustrateContent: '该套组件由数据仓库组件 (Data-Stash)、数据导出组件 (Data-Export)、数据对账组件 (Data-Reconcile) 三个相互独立、可插拔、可灵活组装的子组件构成，提供区块链数据挖掘、裁剪、扩容、可信存储、抽取、分析、审计、对账、监管等数据治理方面的关键能力，满足数据治理全流程开发场景的需求。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/orgs/WeBankBlockchain/repositories',
            studyLink: 'https://data-doc.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        },
        {
          detailsText: {
            title: 'WeBankBlockchain-Governance 多方协作治理',
            img: 'https://static001.geekbang.org/resource/image/71/90/7177d8f39e7fe4e2d6acd5b82ca9e790.png',
            illustrate: [
              {
                illustrateContent: '区块链多方协作治理通用组件由私钥管理组件（Governance-Key）、账户治理组件（Governance-Account）、权限治理组件（Governance-Authority）、证书管理组件（Governance-Cert）等组件构成。它们宛如高速行驶的汽车上的车轮、齿轮、传动组、传感器，协同助力提升应用开发效率。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/orgs/WeBankBlockchain/repositories',
            studyLink: 'https://governance-doc.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        }
      ],
      [
        {
          detailsText: {
            title: 'WeBankBlockchain-OpenLedger 分布式账本',
            img: 'https://static001.geekbang.org/resource/image/99/58/99e5ce56ccb1416dc76ab033c5c6f358.png',
            illustrate: [
              {
                illustrateContent: '在践行区块链技术的路径上，行业需要直观易用、稳健合规，能与业务场景深度融合，合法合规地承载价值和进行流转的分布式账本方案。为此，微众银行区块链结合业务场景，梳理系统脉络，开源了分布式账本解决方案：WeBankBlockchain-OpenLedger。聚焦链上的“用户、业务方、权益、账户和账本”，建立与实际业务相匹配的账本体系，承载数字化权益的完整生命周期，以此形成多方参与的可信分布式账本。在治理方面，支持灵活的角色和权限模型，协助用户和业务方安全稳妥地管理链上账户，具备全面的审计监管能力。通过智能合约封装账本、账户、权益、组织模型，覆盖用户、业务方、托管人的协作关系，使得链上治理符合各行业熟知的运营管理习惯。提供开箱即用的业务级合约，合约支持复用与扩展；在业务层设计友好的接入方式，提供功能丰富、易于使用的接口，简化了业务系统接入的过程，极大地降低了开发成本。建立的区块链分布式账本功能完善、体验友好，可支持消费券、积分、资产证券化等多样化的场景'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/WeBankBlockchain/OpenLedger',
            studyLink: 'https://openledger.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        }
      ],
      [
        {
          detailsText: {
            title: 'WeIdentity 分布式身份管理',
            img: 'https://static001.geekbang.org/resource/image/24/57/2484dfdd03181484f13a89461e6ccb57.png',
            illustrate: [
              {
                illustrateContent: 'WeIdentity 是一套基于区块链的分布式身份管理解决方案，致力于促进泛行业、跨机构、跨地域间的身份认证和数据合作。WeIdentity 提供分布式实体身份标识及管理、可信数据交换协议等一系列的基础层与应用接口，可实现实体对象（人或物）数据的安全授权与交换。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/WeBankBlockchain/WeIdentity',
            studyLink: 'https://weidentity.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        },
        {
          detailsText: {
            title: 'WeDPR 隐私保护',
            img: 'https://static001.geekbang.org/resource/image/92/43/92d7eddb1cb6bf63c201b509f12ffe43.png',
            illustrate: [
              {
                illustrateContent: '致力于解决业务数字化中隐私不“隐”、共享协作不可控等隐私保护风险痛点，在“数据可用不可见”的基础上更进一步，实现隐私数据的“可隐可现、可控可用”的 5C 隐私保护效果，消除隐私主体的隐私顾虑和业务创新的合规壁垒，助力基于隐私数据的核心价值互联和新兴商业探索，营造公平、对等、共赢的多方数据协作环境，达成数据价值跨主体融合和数据治理的可控平衡。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/WeBankBlockchain/WeDPR-Lab-Core',
            studyLink: 'https://wedpr-lab.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        }
      ],
      [
        {
          detailsText: {
            title: 'WeCross 通用跨链',
            img: 'https://static001.geekbang.org/resource/image/c5/06/c57539800c182f73e62a8d564bd44f06.png',
            illustrate: [
              {
                illustrateContent: 'WeCross 致力于促进跨行业、机构和地域的跨区块链信任传递和商业合作，不局限于满足同构区块链平行扩展后的可信数据交换需求，还进一步探索解决异构区块链之间因底层架构、数据结构、接口协议、安全机制等多维异构性导致无法互联互通问题的有效方案。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/WeBankBlockchain/WeCross',
            studyLink: 'https://wecross.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        }
      ],
      [
        {
          detailsText: {
            title: 'WeEvent 消息协作',
            img: 'https://static001.geekbang.org/resource/image/40/6b/401620edb824d10729a4b5fabc3d936b.png',
            illustrate: [
              {
                illustrateContent: 'WeEvent 是一套分布式事件驱动架构，实现了可信、可靠、高效的跨机构、跨平台事件通知机制。WeEvent 致力于提升机构间合作效率，降低合作成本，打通应用程序、物联网、云服务和私有服务等不同平台，最终在不改变已有商业系统的开发语言、接入协议的情况下，实现跨机构、跨平台的事件通知与处理。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/WeBankBlockchain/WeEvent',
            studyLink: 'https://weeventdoc.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        },
        {
          detailsText: {
            title: 'Truora 可信预言机',
            img: 'https://static001.geekbang.org/resource/image/c1/cd/c10d504376594383f21c3164df5cb7cd.png',
            illustrate: [
              {
                illustrateContent: '作为连接联盟链和互联网的桥梁，Truora 致力于为链上链下建立安全可信的数据通道，以降低信任成本，进一步扩宽联盟链应用场景，促进联盟链生态繁荣。作为一整套中心化和多中心化技术方案的集合，用户在使用 Truora 时，可以根据不同的业务场景，以及对信任的要求度，进行灵活部署。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/WeBankBlockchain/Truora',
            studyLink: 'https://truora.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        }
      ],
      [
        {
          detailsText: {
            title: 'Liquid 智能合约语言',
            img: 'https://static001.geekbang.org/resource/image/2e/d8/2eeb19b0b0507925aef51e158f0814d8.png',
            illustrate: [
              {
                illustrateContent: '基于安全（Security）、性能（Performance）、体验（Experience）及定制能力（Customization ）“SPEC” 四个方面的智能合约编程语言设计规范，全新的智能合约编程语言 Liquid 应运而生：支持使用加密原语对数据进行隐匿，从而确保数据资产与逻辑安全；通过优化执行引擎并结合并行化等技术，让智能合约的执行效率取得长足进步；提供敏捷、流畅、友好的开发体验；在语言层提供分布式协作、跨链协同等编程模型，实现灵活可定制。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/WeBankBlockchain/liquid',
            studyLink: 'https://liquid-doc.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        }
      ],
      [
        {
          detailsText: {
            title: 'WeBASE 中间件平台',
            img: 'https://static001.geekbang.org/resource/image/5b/47/5b365e8a95e504c016097d567cd47b47.png',
            illustrate: [
              {
                illustrateContent: 'WeBASE 是在区块链应用和底层节点之间搭建的中间件平台，面向多种对象，根据不同场景，打造丰富的功能组件和实用工具，提供友好的、可视化的可操作环境。WeBASE 可简化区块链应用开发流程，降低开发门槛，帮助开发者快速搭建区块链应用。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/WeBankBlockchain/WeBASE',
            studyLink: 'https://webasedoc.readthedocs.io/zh_CN/latest/',
            study: '学习文档'
          }
        }
      ],
      [
        {
          detailsText: {
            title: 'FISCO BCOS 底层平台',
            img: 'https://static001.geekbang.org/resource/image/f0/65/f0d6ae13511c64e79f086ef8e7ddd765.png',
            illustrate: [
              {
                illustrateContent: 'FISCO BCOS是国产安全可控的联盟链底层平台，由微众银行牵头组建的金链盟开源工作组协作打造，于2017年正式对外开源，为各行各业开展区块链应用提供可靠的基础设施。依托硬核技术实力，FISCO BCOS助力实体经济发展的成效逐渐显现，目前已结出累累硕果。至今，FISCO BCOS开源社区已汇聚超70000名个人成员、逾3000家机构，成功支持政务、金融、农业、公益、文娱、供应链、物联网等多个行业的数百个区块链应用场景落地，社区收集到的标杆应用超过200个，构建出庞大且活跃的联盟链开源生态。'
              }
            ],
            download: '下载源码',
            downloadLink: 'https://github.com/FISCO-BCOS/FISCO-BCOS',
            studyLink: 'https://fisco-bcos-documentation.readthedocs.io/zh_CN/latest/docs/community.html',
            study: '学习文档'
          }
        }
      ]
    ],
  },
  application: {
    codeImg: 'https://static001.geekbang.org/resource/image/21/bc/21665bb2040677b2f42c9aa7eb07ccbc.png',
    title: '扫码下载',
    content: '最新案例集启迪应用灵感',
    contentImg: 'https://static001.geekbang.org/resource/image/37/61/37b8ee6ea033a7yy0c6b0918343b3a61.png',
    contentImgMobile: 'https://static001.geekbang.org/resource/image/ee/ae/ee1bcf3de4a03aaeedc49e565ec790ae.png'
  },
  developcourse: {
    list: [
      {
        imgUrl: require('@/assets/img/support/art_1.png'),
        title: '新人必读：区块链实用型技能树',
        text: '区块链开发需要哪些知识？从哪里入手学习？遇到问题怎么办？本文给区块链领域新人一个快速实用的指引',
        link: 'https://mp.weixin.qq.com/s/YC5TaCbhjQVmNqI3azYd_Q'
      },
      {
        imgUrl: require('@/assets/img/support/webase1.png'),
        title: '区块链中间件平台WeBASE架构/功能概览',
        text: '快速了解WeBASE整体架构和应用开发流程',
        link: 'https://mp.weixin.qq.com/s/gTM9qrXfdFWRKzvv3WYlhg'
      },
      {
        imgUrl: require('@/assets/img/support/art_2.png'),
        title: 'FISCO BCOS零基础入门，五步轻松构建应用',
        text: '以高纯度、超浓缩的极简方式，分享如何快速基于 FISCO BCOS 构建你的第一个DAPP应用',
        link: 'https://mp.weixin.qq.com/s?__biz=MzA3MTI5Njg4Mw==&mid=2247485305&idx=1&sn=5a8dc012880aac6f5cd3dacd7db9f1d9&chksm=9f2ef565a8597c73b87fd248c41d1a5b9b0e6a6c6c527baf873498e351e3cb532b77eda9377a&token=1215467457&lang=zh_CN#rd'
      },
      {
        imgUrl: require('@/assets/img/support/webase2.png'),
        title: 'WeBASE数据导出：助力区块链大数据场景快速落地',
        text: '从用户需求出发，逐层揭开WeBASE数据导出组件功能、特性和架构演进的神秘面纱',
        link: 'https://mp.weixin.qq.com/s/RQ4HoI2B9iN9MtfBzmsnKg'
      },
      {
        imgUrl: require('@/assets/img/support/art_3.png'),
        title: 'FISCO BCOS智能合约开发快速入门',
        text: 'FISCO BCOS平台支持Solidity和Precompiled两种类型的智能合约，同时，提供交互式控制台工具,方便开发者与链进行交互，部署、调用智能合约',
        link: 'https://mp.weixin.qq.com/s/XOVz6S8Z8Jn8NmOfr7UDxA'
      },
      {
        imgUrl: require('@/assets/img/support/webase3.png'),
        title: 'WeBASE节点前置组件功能解析',
        text: '怎样能快速搭建一个区块链可视化界面，以便跟区块链交互，WeBASE-Front就是可以最快满足这个期望的组件',
        link: 'https://mp.weixin.qq.com/s/3V-Vife4_ne0uDvJ6rtcPg'
      },
      {
        imgUrl: require('@/assets/img/support/art_4.png'),
        title: '带你读源码：四大视角多维走读区块链源码',
        text: '区块链涉及领域和知识较多，需要深入源码细节，才能真正完全掌握区块链核心技术',
        link: 'https://mp.weixin.qq.com/s/Erm1XV9n9gmwVn6-8Tda7w'
      },
      {
        imgUrl: require('@/assets/img/support/webase4.png'),
        title: '漫谈WeBASE之交易两三事',
        text: '交易可认为是一段发往区块链系统的请求数据，用于部署合约，调用合约接口，以求达到维护合约的生命周期，管理资产，进行价值交换等目标',
        link: 'https://mp.weixin.qq.com/s/2nMaMFP-3h-XIrWNq5Sjvg'
      }
    ],
    content: {
      list: [
        {
          id: '01',
          idImg: basic.one,
          text: '学习 FISCO BCOS，看这一篇就够了',
          icon: 'https://static001.geekbang.org/resource/image/86/05/8695a119ca677e6b9e128e6036f3b005.png',
          link: 'https://mp.weixin.qq.com/s/70FIPb-Acg1Fe0liotG3qg'
        },
        {
          id: '02',
          idImg: basic.two,
          text: '快速通关中间件平台 WeBASE',
          icon: 'https://static001.geekbang.org/resource/image/86/05/8695a119ca677e6b9e128e6036f3b005.png',
          link: 'https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzU0MDY4MDMzOA==&action=getalbum&album_id=2329805513519235073&scene=173&from_msgid=2247487044&from_itemidx=1&count=3&nolastread=1#wechat_redirect'
        },
        {
          id: '03',
          idImg: basic.three,
          text: '跨链，怎么跨',
          icon: 'https://static001.geekbang.org/resource/image/86/05/8695a119ca677e6b9e128e6036f3b005.png',
          link: 'https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzU0MDY4MDMzOA==&action=getalbum&album_id=1337945984353107969&scene=173&from_msgid=2247484925&from_itemidx=1&count=3&nolastread=1#wechat_redirect'
        },
        {
          id: '04',
          idImg: basic.four,
          text: '隐私计算，这么用',
          icon: 'https://static001.geekbang.org/resource/image/86/05/8695a119ca677e6b9e128e6036f3b005.png',
          link: 'https://mp.weixin.qq.com/mp/appmsgalbum?action=getalbum&__biz=MzU0MDY4MDMzOA==&scene=1&album_id=1379134721778876417&count=3#wechat_redirect'
        },
        {
          id: '05',
          idImg: basic.five,
          text: 'FISCO BCOS 产业应用白皮书',
          icon: 'https://static001.geekbang.org/resource/image/86/05/8695a119ca677e6b9e128e6036f3b005.png',
          link: 'https://mp.weixin.qq.com/s/PD-PUBp-cKHkn7DuE9YlqQ'
        }
      ],
      developImg: 'https://static001.geekbang.org/resource/image/e0/1b/e06f137db86dc0f6433be97d35fe341b.png',
      developImgMbile: 'https://static001.geekbang.org/resource/image/e7/9b/e7f2eb76f3ce3726d59a624d17e1b99b.png',
      moreLabel: '查看更多开发教程',
      icon: 'https://static001.geekbang.org/resource/image/86/05/8695a119ca677e6b9e128e6036f3b005.png',
      moreLink: 'https://mp.weixin.qq.com/s/70FIPb-Acg1Fe0liotG3qg'
    },
    referLabel: '进技术群咨询',
    referLink: '',
    btnText: '查看更多开发教程',
    btnLink: 'https://mp.weixin.qq.com/s/1RGKEdcGhZbjqKv7LBrAVA'
  },
  trainVideo: {
    list: [
      {
        imgUrl: require('@/assets/img/support/art_1.png'),
        title: '新人必读：区块链实用型技能树',
        text: '区块链开发需要哪些知识？从哪里入手学习？遇到问题怎么办？本文给区块链领域新人一个快速实用的指引',
        link: 'https://mp.weixin.qq.com/s/YC5TaCbhjQVmNqI3azYd_Q'
      },
      {
        imgUrl: require('@/assets/img/support/webase1.png'),
        title: '区块链中间件平台WeBASE架构/功能概览',
        text: '快速了解WeBASE整体架构和应用开发流程',
        link: 'https://mp.weixin.qq.com/s/gTM9qrXfdFWRKzvv3WYlhg'
      },
      {
        imgUrl: require('@/assets/img/support/art_2.png'),
        title: 'FISCO BCOS零基础入门，五步轻松构建应用',
        text: '以高纯度、超浓缩的极简方式，分享如何快速基于 FISCO BCOS 构建你的第一个DAPP应用',
        link: 'https://mp.weixin.qq.com/s?__biz=MzA3MTI5Njg4Mw==&mid=2247485305&idx=1&sn=5a8dc012880aac6f5cd3dacd7db9f1d9&chksm=9f2ef565a8597c73b87fd248c41d1a5b9b0e6a6c6c527baf873498e351e3cb532b77eda9377a&token=1215467457&lang=zh_CN#rd'
      },
      {
        imgUrl: require('@/assets/img/support/webase2.png'),
        title: 'WeBASE数据导出：助力区块链大数据场景快速落地',
        text: '从用户需求出发，逐层揭开WeBASE数据导出组件功能、特性和架构演进的神秘面纱',
        link: 'https://mp.weixin.qq.com/s/RQ4HoI2B9iN9MtfBzmsnKg'
      }
    ],
    referLabel: '进技术群咨询',
    referLink: '',
    moreLabel: '查看更多开发教程',
    moreLink: 'https://mp.weixin.qq.com/s/1RGKEdcGhZbjqKv7LBrAVA'
  },
  training: {
    list: [
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/1b/4c/1be30e544ea9798691777415ce60c84c.png',
        contentText: '微众区块链 | 构筑 ESG 可信基础设施',
        video: 'https://mp.weixin.qq.com/s/CVta_0a3I6SMWX5YzYsCCw'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/01/d2/01d7ffd37e6f92486751b7101293yyd2.png',
        contentText: 'FISCO BCOS 实操演示',
        video: 'https://v.qq.com/x/page/t3130e6wzh2.html'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/1c/ac/1c47652baf1daf231b70d60d73138aac.png',
        contentText: '智能合约速成教程',
        video: 'https://v.qq.com/x/page/h3130tubdoz.html'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/b8/6f/b89909847bda44b30f7d2c18d68b186f.png',
        contentText: 'FISCO BCOS 极速开发教程',
        video: 'https://mp.weixin.qq.com/s/-EquunJPW9BuXfP9dPI-bA'
      }
    ],
    buttonText: '查看更多开发教程',
    buttonLink: 'https://mp.weixin.qq.com/s/70FIPb-Acg1Fe0liotG3qg'
  },
  bottom: {
    imgLeft: 'https://static001.geekbang.org/resource/image/0d/09/0daf0bb0cfd240e4315c1865d6f85509.png',
    textLeft: 'FISCO BCOS 开源社区',
    imgRight: 'https://static001.geekbang.org/resource/image/58/19/5847ca05bc140fd25454cf19d358a819.png',
    textRight: '微众区块链',
    qrGongzhonghao: '扫码关注公众号',
    qrText: '了解更多资讯',
  }
}
